export const fiveBoroughs = [
  "bronx",
  "queens",
  "brooklyn",
  "staten island",
  "manhattan",
];

export const primaryCities = [
  {
    id: 21,
    neighborhood: "",
    city: "Atlanta",
    state: "GA",
    latitude: 33.749,
    longitude: -84.388,
    slug: "atlanta",
  },
  {
    id: 25,
    neighborhood: "",
    city: "Austin",
    state: "TX",
    latitude: 30.2672,
    longitude: -97.7431,
    slug: "austin",
  },
  {
    id: 39,
    neighborhood: "",
    city: "Boston",
    state: "MA",
    latitude: 42.3601,
    longitude: -71.0589,
    slug: "boston",
  },
  {
    id: 70,
    neighborhood: "",
    city: "Chicago",
    state: "IL",
    latitude: 41.8781,
    longitude: -87.6298,
    slug: "chicago",
  },
  {
    id: 108,
    neighborhood: "",
    city: "Denver",
    state: "CO",
    latitude: 39.7392,
    longitude: -104.9903,
    slug: "denver",
  },
  {
    id: 178,
    neighborhood: "",
    city: "Honolulu",
    state: "HI",
    latitude: 21.3069,
    longitude: -157.8583,
    slug: "honolulu",
  },
  {
    id: 179,
    neighborhood: "",
    city: "Houston",
    state: "TX",
    latitude: 29.7604,
    longitude: -95.3698,
    slug: "houston",
  },
  {
    id: 191,
    neighborhood: "",
    city: "Jersey City",
    state: "NJ",
    latitude: 40.7282,
    longitude: -74.0776,
    slug: "jersey-city",
  },
  {
    id: 219,
    neighborhood: "",
    city: "Los Angeles",
    state: "CA",
    latitude: 34.0522,
    longitude: -118.2437,
    slug: "los-angeles",
  },
  {
    id: 241,
    neighborhood: "",
    city: "Miami",
    state: "FL",
    latitude: 25.7617,
    longitude: -80.1918,
    slug: "miami",
  },
  {
    id: 266,
    neighborhood: "",
    city: "New Haven",
    state: "CT",
    latitude: 41.3083,
    longitude: -72.9279,
    slug: "new-haven",
  },
  {
    id: 268,
    neighborhood: "",
    city: "New York",
    state: "NY",
    latitude: 40.7128,
    longitude: -74.006,
    slug: "new-york",
  },
  {
    id: 301,
    neighborhood: "",
    city: "Philadelphia",
    state: "PA",
    latitude: 39.9526,
    longitude: -75.1652,
    slug: "philadelphia",
  },
  {
    id: 343,
    neighborhood: "",
    city: "Sacramento",
    state: "CA",
    latitude: 38.5816,
    longitude: -121.4944,
    slug: "sacramento",
  },
  {
    id: 351,
    neighborhood: "",
    city: "San Diego",
    state: "CA",
    latitude: 32.7157,
    longitude: -117.1611,
    slug: "san-diego",
  },
  {
    id: 352,
    neighborhood: "",
    city: "San Francisco",
    state: "CA",
    latitude: 37.7749,
    longitude: -122.4194,
    slug: "san-francisco",
  },
  {
    id: 366,
    neighborhood: "",
    city: "Seattle",
    state: "WA",
    latitude: 47.6062,
    longitude: -122.3321,
    slug: "seattle",
  },
  {
    id: 430,
    neighborhood: "",
    city: "Washington",
    state: "DC",
    latitude: 38.9072,
    longitude: -77.0369,
    slug: "washington",
  },
];

export const mostPopularCityData = [
  {
    id: 0,
    city: "Albany",
    state: "NY",
    latitude: 42.6677,
    longitude: -74.106,
    slug: "albany",
  },
  {
    id: 1,
    city: "Albuquerque",
    state: "NM",
    latitude: 35.1107,
    longitude: -106.6099,
    slug: "albuquerque",
  },
  {
    id: 2,
    city: "Arlington",
    state: "TX",
    latitude: 32.7357,
    longitude: -97.1082,
    slug: "arlington",
  },
  {
    id: 3,
    city: "Atlanta",
    state: "GA",
    latitude: 33.749,
    longitude: -84.388,
    slug: "atlanta",
  },
  {
    id: 4,
    city: "Austin",
    state: "TX",
    latitude: 30.2672,
    longitude: -97.7431,
    slug: "austin",
  },
  {
    id: 5,
    city: "Baltimore",
    state: "MD",
    latitude: 39.2904,
    longitude: -76.6122,
    slug: "baltimore",
  },
  {
    id: 6,
    city: "Boston",
    state: "MA",
    latitude: 42.3601,
    longitude: -71.0589,
    slug: "boston",
  },
  {
    id: 7,
    city: "Charlotte",
    state: "NC",
    latitude: 35.2271,
    longitude: -80.8431,
    slug: "charlotte",
  },
  {
    id: 8,
    city: "Chicago",
    state: "IL",
    latitude: 41.8781,
    longitude: -87.6298,
    slug: "chicago",
  },
  {
    id: 9,
    city: "Colorado Springs",
    state: "CO",
    latitude: 38.8339,
    longitude: -104.8214,
    slug: "colorado-springs",
  },
  {
    id: 10,
    city: "Columbus",
    state: "OH",
    latitude: 39.9612,
    longitude: -82.9988,
    slug: "columbus",
  },
  {
    id: 11,
    city: "Corpus Christi",
    state: "TX",
    latitude: 27.8006,
    longitude: -97.3995,
    slug: "corpus-christi",
  },
  {
    id: 12,
    city: "Dallas",
    state: "TX",
    latitude: 32.7767,
    longitude: -96.797,
    slug: "dallas",
  },
  {
    id: 13,
    city: "Denver",
    state: "CO",
    latitude: 39.7392,
    longitude: -104.9903,
    slug: "denver",
  },
  {
    id: 14,
    city: "Detroit",
    state: "MI",
    latitude: 42.3314,
    longitude: -83.0458,
    slug: "detroit",
  },
  {
    id: 15,
    city: "El Paso",
    state: "TX",
    latitude: 31.7619,
    longitude: -106.485,
    slug: "el-paso",
  },
  {
    id: 16,
    city: "Fort Worth",
    state: "TX",
    latitude: 32.7555,
    longitude: -97.3308,
    slug: "fort-worth",
  },
  {
    id: 17,
    city: "Fresno",
    state: "CA",
    latitude: 36.7378,
    longitude: -119.7825,
    slug: "fresno",
  },
  {
    id: 18,
    neighborhood: "",
    city: "Hartford",
    state: "CT",
    latitude: 41.7655,
    longitude: -72.6733,
    slug: "hartford",
  },
  {
    id: 19,
    neighborhood: "",
    city: "Honolulu",
    state: "HI",
    latitude: 21.3069,
    longitude: -157.8583,
    slug: "honolulu",
  },
  {
    id: 20,
    city: "Houston",
    state: "TX",
    latitude: 29.7604,
    longitude: -95.3698,
    slug: "houston",
  },
  {
    id: 21,
    city: "Indianapolis",
    state: "IN",
    latitude: 39.7684,
    longitude: -86.158,
    slug: "indianapolis",
  },
  {
    id: 22,
    city: "Jacksonville",
    state: "FL",
    latitude: 30.3322,
    longitude: -81.6557,
    slug: "jacksonville",
  },
  {
    id: 23,
    city: "Jersey City",
    state: "NJ",
    latitude: 40.7282,
    longitude: -74.0776,
    slug: "jersey-city",
  },
  {
    id: 24,
    city: "Kansas City",
    state: "MO",
    latitude: 39.0997,
    longitude: -94.5786,
    slug: "kansas-city",
  },
  {
    id: 25,
    city: "Las Vegas",
    state: "NV",
    latitude: 36.1699,
    longitude: -115.1398,
    slug: "las-vegas",
  },
  {
    id: 26,
    city: "Long Beach",
    state: "CA",
    latitude: 33.7701,
    longitude: -118.1937,
    slug: "long-beach",
  },
  {
    id: 27,
    city: "Los Angeles",
    state: "CA",
    latitude: 34.0522,
    longitude: -118.2437,
    slug: "los-angeles",
  },
  {
    id: 28,
    city: "Louisville",
    state: "KY",
    latitude: 38.2527,
    longitude: -85.7585,
    slug: "louisville",
  },
  {
    id: 29,
    city: "Memphis",
    state: "TN",
    latitude: 35.1495,
    longitude: -90.049,
    slug: "memphis",
  },
  {
    id: 30,
    city: "Mesa",
    state: "AZ",
    latitude: 33.4152,
    longitude: -111.8315,
    slug: "mesa",
  },
  {
    id: 31,
    city: "Miami",
    state: "FL",
    latitude: 25.7617,
    longitude: -80.1918,
    slug: "miami",
  },
  {
    id: 32,
    city: "Milwaukee",
    state: "WI",
    latitude: 43.0389,
    longitude: -87.9065,
    slug: "milwaukee",
  },
  {
    id: 33,
    city: "Minneapolis",
    state: "MN",
    latitude: 44.9778,
    longitude: -93.265,
    slug: "minneapolis",
  },
  {
    id: 34,
    city: "Nashville",
    state: "TN",
    latitude: 36.1627,
    longitude: -86.7816,
    slug: "nashville",
  },
  {
    id: 35,
    city: "New Haven",
    state: "CT",
    latitude: 41.3083,
    longitude: -72.9242,
    slug: "new-haven",
  },
  {
    id: 36,
    city: "New Orleans",
    state: "LA",
    latitude: 29.9511,
    longitude: -90.0715,
    slug: "new-orleans",
  },
  {
    id: 37,
    city: "New York",
    state: "NY",
    latitude: 40.7128,
    longitude: -74.006,
    slug: "new-york",
  },
  {
    id: 38,
    city: "Oakland",
    state: "CA",
    latitude: 37.8044,
    longitude: -122.2712,
    slug: "oakland",
  },
  {
    id: 39,
    city: "Oklahoma City",
    state: "OK",
    latitude: 35.4676,
    longitude: -97.5164,
    slug: "oklahoma-city",
  },
  {
    id: 40,
    city: "Omaha",
    state: "NE",
    latitude: 41.2565,
    longitude: -95.9345,
    slug: "omaha",
  },
  {
    id: 41,
    city: "Philadelphia",
    state: "PA",
    latitude: 39.9526,
    longitude: -75.1652,
    slug: "philadelphia",
  },
  {
    id: 42,
    city: "Phoenix",
    state: "AZ",
    latitude: 33.4484,
    longitude: -112.074,
    slug: "phoenix",
  },
  {
    id: 43,
    city: "Portland",
    state: "OR",
    latitude: 45.5152,
    longitude: -122.6784,
    slug: "portland",
  },
  {
    id: 44,
    city: "Raleigh",
    state: "NC",
    latitude: 35.7796,
    longitude: -78.6382,
    slug: "raleigh",
  },
  {
    id: 45,
    city: "Sacramento",
    state: "CA",
    latitude: 38.5816,
    longitude: -121.4944,
    slug: "sacramento",
  },
  {
    id: 46,
    city: "San Antonio",
    state: "TX",
    latitude: 29.4241,
    longitude: -98.4936,
    slug: "san-antonio",
  },
  {
    id: 47,
    city: "San Diego",
    state: "CA",
    latitude: 32.7157,
    longitude: -117.1611,
    slug: "san-diego",
  },
  {
    id: 48,
    city: "San Francisco",
    state: "CA",
    latitude: 37.7749,
    longitude: -122.4194,
    slug: "san-francisco",
  },
  {
    id: 49,
    city: "San Jose",
    state: "CA",
    latitude: 37.3382,
    longitude: -121.8863,
    slug: "san-jose",
  },
  {
    id: 50,
    city: "Seattle",
    state: "WA",
    latitude: 47.6062,
    longitude: -122.3321,
    slug: "seattle",
  },
  {
    id: 51,
    city: "Tacoma",
    state: "WA",
    latitude: 47.2529,
    longitude: -122.4443,
    slug: "tacoma",
  },
  {
    id: 52,
    city: "Tucson",
    state: "AZ",
    latitude: 32.2217,
    longitude: -110.9265,
    slug: "tucson",
  },
  {
    id: 53,
    city: "Tulsa",
    state: "OK",
    latitude: 36.154,
    longitude: -95.9928,
    slug: "tulsa",
  },
  {
    id: 54,
    city: "Virginia Beach",
    state: "VA",
    latitude: 36.8529,
    longitude: -75.978,
    slug: "virginia-beach",
  },
  {
    id: 55,
    city: "Washington",
    state: "D.C.",
    latitude: 38.9072,
    longitude: -77.0369,
    slug: "washington",
  },
  {
    id: 56,
    city: "Wichita",
    state: "KS",
    latitude: 37.6877,
    longitude: -97.33,
    slug: "wichita",
  },
];

// uncomment if you want to use cityAutoComplete function in ../helpers
export const allCities = [
  //   {
  //     id: 1,
  //     name: "abilene",
  //     state: "tx",
  //     population: 126938,
  //     latitude: 32.448734,
  //     longitude: -99.733147,
  //   },
  //   {
  //     id: 2,
  //     name: "akron",
  //     state: "oh",
  //     population: 218739,
  //     latitude: 41.0472,
  //     longitude: -81.5169,
  //   },
  //   {
  //     id: 3,
  //     name: "alameda",
  //     state: "ca",
  //     population: 78280,
  //     latitude: 37.765205,
  //     longitude: -122.241638,
  //   },
  //   {
  //     id: 4,
  //     name: "albany",
  //     state: "ny",
  //     population: 99224,
  //     latitude: 42.652579,
  //     longitude: -73.756232,
  //   },
  //   {
  //     id: 5,
  //     name: "albuquerque",
  //     state: "nm",
  //     population: 560326,
  //     latitude: 35.0844,
  //     longitude: -106.6504,
  //   },
  //   {
  //     id: 6,
  //     name: "alexandria",
  //     state: "va",
  //     population: 159428,
  //     latitude: 38.8048,
  //     longitude: -77.0469,
  //   },
  //   {
  //     id: 7,
  //     name: "allen",
  //     state: "tx",
  //     population: 105658,
  //     latitude: 33.10047,
  //     longitude: -96.67448,
  //   },
  //   {
  //     id: 8,
  //     name: "allentown",
  //     state: "pa",
  //     population: 118032,
  //     latitude: 40.6083,
  //     longitude: -75.4902,
  //   },
  //   {
  //     id: 9,
  //     name: "amarillo",
  //     state: "tx",
  //     population: 196429,
  //     latitude: 35.1921,
  //     longitude: -101.7257,
  //   },
  //   {
  //     id: 10,
  //     name: "anaheim",
  //     state: "ca",
  //     population: 340512,
  //     latitude: 33.8353,
  //     longitude: -117.9143,
  //   },
  //   {
  //     id: 11,
  //     name: "anchorage",
  //     state: "ak",
  //     population: 286075,
  //     latitude: 61.2181,
  //     longitude: -149.9003,
  //   },
  //   {
  //     id: 12,
  //     name: "ann arbor",
  //     state: "mi",
  //     population: 120717,
  //     latitude: 42.2808,
  //     longitude: -83.743,
  //   },
  //   {
  //     id: 13,
  //     name: "annandale",
  //     state: "va",
  //     population: 43362,
  //     latitude: 38.834134,
  //     longitude: -77.211277,
  //   },
  //   {
  //     id: 14,
  //     name: "antioch",
  //     state: "ca",
  //     population: 115291,
  //     latitude: 38.005001,
  //     longitude: -121.805832,
  //   },
  //   {
  //     id: 15,
  //     name: "apple valley",
  //     state: "mn",
  //     population: 56374,
  //     latitude: 44.7456,
  //     longitude: -93.2186,
  //   },
  //   {
  //     id: 16,
  //     name: "arlington",
  //     state: "ca",
  //     population: 43532,
  //     latitude: 33.9189,
  //     longitude: -117.4464,
  //   },
  //   {
  //     id: 17,
  //     name: "arlington",
  //     state: "tx",
  //     population: 398431,
  //     latitude: 32.7357,
  //     longitude: -97.1082,
  //   },
  //   {
  //     id: 18,
  //     name: "arlington",
  //     state: "va",
  //     population: 236893,
  //     latitude: 38.8817,
  //     longitude: -77.103,
  //   },
  //   {
  //     id: 19,
  //     name: "ashburn",
  //     state: "va",
  //     population: 43511,
  //     latitude: 39.04664,
  //     longitude: -77.47129,
  //   },
  //   {
  //     id: 20,
  //     name: "athens-clarke county",
  //     state: "ga",
  //     population: 103238,
  //     latitude: 33.9519,
  //     longitude: -83.3576,
  //   },
  //   {
  //     id: 21,
  //     name: "atlanta",
  //     state: "ga",
  //     population: 520070,
  //     latitude: 33.749,
  //     longitude: -84.388,
  //   },
  //   {
  //     id: 22,
  //     name: "augusta-richmond county",
  //     state: "ga",
  //     population: 217621,
  //     latitude: 33.47,
  //     longitude: -81.97,
  //   },
  //   {
  //     id: 23,
  //     name: "aurora",
  //     state: "co",
  //     population: 395052,
  //     latitude: 39.7294,
  //     longitude: -104.8319,
  //   },
  //   {
  //     id: 24,
  //     name: "aurora",
  //     state: "il",
  //     population: 182744,
  //     latitude: 41.7487,
  //     longitude: -88.3121,
  //   },
  //   {
  //     id: 25,
  //     name: "austin",
  //     state: "tx",
  //     population: 993588,
  //     latitude: 30.2672,
  //     longitude: -97.7431,
  //   },
  //   {
  //     id: 26,
  //     name: "bakersfield",
  //     state: "ca",
  //     population: 413381,
  //     latitude: 35.3733,
  //     longitude: -119.0187,
  //   },
  //   {
  //     id: 27,
  //     name: "baltimore",
  //     state: "md",
  //     population: 568271,
  //     latitude: 39.2904,
  //     longitude: -76.6122,
  //   },
  //   {
  //     id: 28,
  //     name: "baton rouge",
  //     state: "la",
  //     population: 220236,
  //     latitude: 30.4515,
  //     longitude: -91.1871,
  //   },
  //   {
  //     id: 29,
  //     name: "bayonne",
  //     state: "nj",
  //     population: 71686,
  //     latitude: 40.6681,
  //     longitude: -74.1165,
  //   },
  //   {
  //     id: 30,
  //     name: "baytown",
  //     state: "tx",
  //     population: 78000,
  //     latitude: 29.7438,
  //     longitude: -95.0069,
  //   },
  //   {
  //     id: 31,
  //     name: "bedford-stuyvesant",
  //     state: "ny",
  //     population: 174960,
  //     latitude: 40.6865,
  //     longitude: -73.9431,
  //   },
  //   {
  //     id: 32,
  //     name: "berkeley",
  //     state: "ca",
  //     population: 121054,
  //     latitude: 37.8716,
  //     longitude: -122.2713,
  //   },
  //   {
  //     id: 33,
  //     name: "billings",
  //     state: "mt",
  //     population: 119965,
  //     latitude: 45.7833,
  //     longitude: -108.5007,
  //   },
  //   {
  //     id: 34,
  //     name: "birmingham",
  //     state: "al",
  //     population: 200000,
  //     latitude: 33.5207,
  //     longitude: -86.8024,
  //   },
  //   {
  //     id: 35,
  //     name: "blaine",
  //     state: "mn",
  //     population: 69327,
  //     latitude: 45.1633,
  //     longitude: -93.2666,
  //   },
  //   {
  //     id: 36,
  //     name: "boca raton",
  //     state: "fl",
  //     population: 99808,
  //     latitude: 26.3587,
  //     longitude: -80.0833,
  //   },
  //   {
  //     id: 37,
  //     name: "boise",
  //     state: "id",
  //     population: 235421,
  //     latitude: 43.615,
  //     longitude: -116.2023,
  //   },
  //   {
  //     id: 38,
  //     name: "bolingbrook",
  //     state: "il",
  //     population: 75787,
  //     latitude: 41.6961,
  //     longitude: -88.0809,
  //   },
  //   {
  //     id: 39,
  //     name: "boston",
  //     state: "ma",
  //     population: 673458,
  //     latitude: 42.3601,
  //     longitude: -71.0589,
  //   },
  //   {
  //     id: 40,
  //     name: "boynton beach",
  //     state: "fl",
  //     population: 83935,
  //     latitude: 26.5242,
  //     longitude: -80.0847,
  //   },
  //   {
  //     id: 41,
  //     name: "bridgeport",
  //     state: "ct",
  //     population: 148654,
  //     latitude: 41.1642,
  //     longitude: -73.197,
  //   },
  //   {
  //     id: 42,
  //     name: "brockton",
  //     state: "ma",
  //     population: 105643,
  //     latitude: 42.0834,
  //     longitude: -71.0184,
  //   },
  //   {
  //     id: 43,
  //     name: "bronx",
  //     state: "ny",
  //     population: 1424933,
  //     latitude: 40.8448,
  //     longitude: -73.8648,
  //   },
  //   {
  //     id: 44,
  //     name: "brooklyn",
  //     state: "ny",
  //     population: 2736074,
  //     latitude: 40.6782,
  //     longitude: -73.9442,
  //   },
  //   {
  //     id: 45,
  //     name: "brooklyn park",
  //     state: "mn",
  //     population: 81682,
  //     latitude: 45.1058,
  //     longitude: -93.3644,
  //   },
  //   {
  //     id: 46,
  //     name: "brownsville",
  //     state: "tx",
  //     population: 187680,
  //     latitude: 25.901,
  //     longitude: -97.4975,
  //   },
  //   {
  //     id: 47,
  //     name: "bryan",
  //     state: "tx",
  //     population: 85934,
  //     latitude: 30.6757,
  //     longitude: -96.3683,
  //   },
  //   {
  //     id: 48,
  //     name: "buffalo",
  //     state: "ny",
  //     population: 274678,
  //     latitude: 42.8864,
  //     longitude: -78.8784,
  //   },
  //   {
  //     id: 49,
  //     name: "burbank",
  //     state: "ca",
  //     population: 103608,
  //     latitude: 34.1808,
  //     longitude: -118.3006,
  //   },
  //   {
  //     id: 50,
  //     name: "burke",
  //     state: "va",
  //     population: 43532,
  //     latitude: 38.7754,
  //     longitude: -77.2658,
  //   },
  //   {
  //     id: 51,
  //     name: "burnsville",
  //     state: "mn",
  //     population: 64317,
  //     latitude: 44.7772,
  //     longitude: -93.2755,
  //   },
  //   {
  //     id: 52,
  //     name: "bushwick",
  //     state: "ny",
  //     population: 120747,
  //     latitude: 40.6944,
  //     longitude: -73.9213,
  //   },
  //   {
  //     id: 53,
  //     name: "cambridge",
  //     state: "ma",
  //     population: 119565,
  //     latitude: 42.3736,
  //     longitude: -71.1097,
  //   },
  //   {
  //     id: 54,
  //     name: "camden",
  //     state: "nj",
  //     population: 71791,
  //     latitude: 39.9452,
  //     longitude: -75.1278,
  //   },
  //   {
  //     id: 55,
  //     name: "cape coral",
  //     state: "fl",
  //     population: 165831,
  //     latitude: 26.5628,
  //     longitude: -81.9497,
  //   },
  //   {
  //     id: 56,
  //     name: "carlsbad",
  //     state: "ca",
  //     population: 114747,
  //     latitude: 33.1581,
  //     longitude: -117.3506,
  //   },
  //   {
  //     id: 57,
  //     name: "carrollton",
  //     state: "tx",
  //     population: 133446,
  //     latitude: 32.9912,
  //     longitude: -96.8893,
  //   },
  //   {
  //     id: 58,
  //     name: "cary",
  //     state: "nc",
  //     population: 176987,
  //     latitude: 35.7909,
  //     longitude: -78.7812,
  //   },
  //   {
  //     id: 59,
  //     name: "cedar rapids",
  //     state: "ia",
  //     population: 137456,
  //     latitude: 41.9778,
  //     longitude: -91.6656,
  //   },
  //   {
  //     id: 60,
  //     name: "centennial",
  //     state: "co",
  //     population: 110903,
  //     latitude: 39.5886,
  //     longitude: -104.9022,
  //   },
  //   {
  //     id: 61,
  //     name: "centreville",
  //     state: "va",
  //     population: 71131,
  //     latitude: 38.8251,
  //     longitude: -77.4264,
  //   },
  //   {
  //     id: 62,
  //     name: "champaign",
  //     state: "il",
  //     population: 89163,
  //     latitude: 40.1164,
  //     longitude: -88.2434,
  //   },
  //   {
  //     id: 63,
  //     name: "chandler",
  //     state: "az",
  //     population: 280167,
  //     latitude: 33.3062,
  //     longitude: -111.8413,
  //   },
  //   {
  //     id: 64,
  //     name: "charleston",
  //     state: "sc",
  //     population: 132609,
  //     latitude: 32.7765,
  //     longitude: -79.9311,
  //   },
  //   {
  //     id: 65,
  //     name: "charlotte",
  //     state: "nc",
  //     population: 943476,
  //     latitude: 35.2271,
  //     longitude: -80.8431,
  //   },
  //   {
  //     id: 66,
  //     name: "charlottesville",
  //     state: "va",
  //     population: 48106,
  //     latitude: 38.0293,
  //     longitude: -78.4767,
  //   },
  //   {
  //     id: 67,
  //     name: "chattanooga",
  //     state: "tn",
  //     population: 182312,
  //     latitude: 35.0457,
  //     longitude: -85.3097,
  //   },
  //   {
  //     id: 68,
  //     name: "chelsea",
  //     state: "ny",
  //     population: 65000,
  //     latitude: 40.7486,
  //     longitude: -74.0029,
  //   },
  //   {
  //     id: 69,
  //     name: "chesapeake",
  //     state: "va",
  //     population: 253886,
  //     latitude: 36.7725,
  //     longitude: -76.2891,
  //   },
  //   {
  //     id: 70,
  //     name: "chicago",
  //     state: "il",
  //     population: 2721308,
  //     latitude: 41.8781,
  //     longitude: -87.6298,
  //   },
  //   {
  //     id: 71,
  //     name: "chula vista",
  //     state: "ca",
  //     population: 274333,
  //     latitude: 32.6401,
  //     longitude: -117.0843,
  //   },
  //   {
  //     id: 72,
  //     name: "cicero",
  //     state: "il",
  //     population: 82061,
  //     latitude: 41.8464,
  //     longitude: -87.7412,
  //   },
  //   {
  //     id: 73,
  //     name: "cincinnati",
  //     state: "oh",
  //     population: 311097,
  //     latitude: 39.1031,
  //     longitude: -84.512,
  //   },
  //   {
  //     id: 74,
  //     name: "clarksville",
  //     state: "tn",
  //     population: 166743,
  //     latitude: 36.5298,
  //     longitude: -87.3595,
  //   },
  //   {
  //     id: 75,
  //     name: "clearwater",
  //     state: "fl",
  //     population: 108687,
  //     latitude: 27.9659,
  //     longitude: -82.8001,
  //   },
  //   {
  //     id: 76,
  //     name: "cleveland",
  //     state: "oh",
  //     population: 362656,
  //     latitude: 41.4993,
  //     longitude: -81.6944,
  //   },
  //   {
  //     id: 77,
  //     name: "clifton",
  //     state: "nj",
  //     population: 86326,
  //     latitude: 40.8576,
  //     longitude: -74.1632,
  //   },
  //   {
  //     id: 78,
  //     name: "college station",
  //     state: "tx",
  //     population: 122177,
  //     latitude: 30.6015,
  //     longitude: -96.3359,
  //   },
  //   {
  //     id: 79,
  //     name: "colorado springs",
  //     state: "co",
  //     population: 488664,
  //     latitude: 38.834,
  //     longitude: -104.8214,
  //   },
  //   {
  //     id: 80,
  //     name: "columbia",
  //     state: "mo",
  //     population: 129774,
  //     latitude: 38.9517,
  //     longitude: -92.3341,
  //   },
  //   {
  //     id: 81,
  //     name: "columbia",
  //     state: "sc",
  //     population: 138075,
  //     latitude: 34.0007,
  //     longitude: -81.0348,
  //   },
  //   {
  //     id: 82,
  //     name: "columbus",
  //     state: "ga",
  //     population: 202824,
  //     latitude: 32.4609,
  //     longitude: -84.9758,
  //   },
  //   {
  //     id: 83,
  //     name: "columbus",
  //     state: "oh",
  //     population: 933263,
  //     latitude: 39.9612,
  //     longitude: -82.9988,
  //   },
  //   {
  //     id: 84,
  //     name: "compton",
  //     state: "ca",
  //     population: 95689,
  //     latitude: 33.8967,
  //     longitude: -118.2285,
  //   },
  //   {
  //     id: 85,
  //     name: "concord",
  //     state: "ca",
  //     population: 122067,
  //     latitude: 37.9779,
  //     longitude: -122.031,
  //   },
  //   {
  //     id: 86,
  //     name: "concord",
  //     state: "nh",
  //     population: 43976,
  //     latitude: 43.2081,
  //     longitude: -71.5376,
  //   },
  //   {
  //     id: 87,
  //     name: "coney island",
  //     state: "ny",
  //     population: 108905,
  //     latitude: 40.575,
  //     longitude: -73.987,
  //   },
  //   {
  //     id: 88,
  //     name: "conroe",
  //     state: "tx",
  //     population: 106096,
  //     latitude: 30.3113,
  //     longitude: -95.4568,
  //   },
  //   {
  //     id: 89,
  //     name: "coon rapids",
  //     state: "mn",
  //     population: 63931,
  //     latitude: 45.1633,
  //     longitude: -93.308,
  //   },
  //   {
  //     id: 90,
  //     name: "coral springs",
  //     state: "fl",
  //     population: 134375,
  //     latitude: 26.2712,
  //     longitude: -80.2709,
  //   },
  //   {
  //     id: 91,
  //     name: "corona",
  //     state: "ca",
  //     population: 159503,
  //     latitude: 33.8753,
  //     longitude: -117.5668,
  //   },
  //   {
  //     id: 92,
  //     name: "corpus christi",
  //     state: "tx",
  //     population: 316595,
  //     latitude: 27.8006,
  //     longitude: -97.3964,
  //   },
  //   {
  //     id: 93,
  //     name: "costa mesa",
  //     state: "ca",
  //     population: 112108,
  //     latitude: 33.6405,
  //     longitude: -117.9189,
  //   },
  //   {
  //     id: 94,
  //     name: "council bluffs",
  //     state: "ia",
  //     population: 62294,
  //     latitude: 41.2586,
  //     longitude: -95.8572,
  //   },
  //   {
  //     id: 95,
  //     name: "cranston",
  //     state: "ri",
  //     population: 82348,
  //     latitude: 41.777,
  //     longitude: -71.4239,
  //   },
  //   {
  //     id: 96,
  //     name: "crown heights",
  //     state: "ny",
  //     population: 108259,
  //     latitude: 40.6726,
  //     longitude: -73.9431,
  //   },
  //   {
  //     id: 97,
  //     name: "dallas",
  //     state: "tx",
  //     population: 1326087,
  //     latitude: 32.7767,
  //     longitude: -96.797,
  //   },
  //   {
  //     id: 98,
  //     name: "daly city",
  //     state: "ca",
  //     population: 104901,
  //     latitude: 37.7083,
  //     longitude: -122.4705,
  //   },
  //   {
  //     id: 99,
  //     name: "davenport",
  //     state: "ia",
  //     population: 102008,
  //     latitude: 41.5236,
  //     longitude: -90.577,
  //   },
  //   {
  //     id: 100,
  //     name: "davie",
  //     state: "fl",
  //     population: 108390,
  //     latitude: 26.0776,
  //     longitude: -80.2798,
  //   },
  //   {
  //     id: 101,
  //     name: "dayton",
  //     state: "oh",
  //     population: 135944,
  //     latitude: 39.7589,
  //     longitude: -84.1916,
  //   },
  //   {
  //     id: 102,
  //     name: "dearborn",
  //     state: "mi",
  //     population: 108520,
  //     latitude: 42.3222,
  //     longitude: -83.1763,
  //   },
  //   {
  //     id: 103,
  //     name: "dearborn heights",
  //     state: "mi",
  //     population: 59976,
  //     latitude: 42.3283,
  //     longitude: -83.2721,
  //   },
  //   {
  //     id: 104,
  //     name: "decatur",
  //     state: "il",
  //     population: 70741,
  //     latitude: 39.8403,
  //     longitude: -88.9542,
  //   },
  //   {
  //     id: 105,
  //     name: "deerfield beach",
  //     state: "fl",
  //     population: 86326,
  //     latitude: 26.3195,
  //     longitude: -80.1012,
  //   },
  //   {
  //     id: 106,
  //     name: "deltona",
  //     state: "fl",
  //     population: 100513,
  //     latitude: 28.9167,
  //     longitude: -81.25,
  //   },
  //   {
  //     id: 107,
  //     name: "denton",
  //     state: "tx",
  //     population: 146909,
  //     latitude: 33.2109,
  //     longitude: -97.1332,
  //   },
  //   {
  //     id: 108,
  //     name: "denver",
  //     state: "co",
  //     population: 729019,
  //     latitude: 39.7392,
  //     longitude: -104.9903,
  //   },
  //   {
  //     id: 109,
  //     name: "des moines",
  //     state: "ia",
  //     population: 207510,
  //     latitude: 41.6005,
  //     longitude: -93.6091,
  //   },
  //   {
  //     id: 110,
  //     name: "detroit",
  //     state: "mi",
  //     population: 645705,
  //     latitude: 42.3314,
  //     longitude: -83.0458,
  //   },
  //   {
  //     id: 111,
  //     name: "downey",
  //     state: "ca",
  //     population: 111772,
  //     latitude: 33.9409,
  //     longitude: -118.134,
  //   },
  //   {
  //     id: 112,
  //     name: "duluth",
  //     state: "mn",
  //     population: 86607,
  //     latitude: 46.7867,
  //     longitude: -92.1005,
  //   },
  //   {
  //     id: 113,
  //     name: "durham",
  //     state: "nc",
  //     population: 296186,
  //     latitude: 35.994,
  //     longitude: -78.8986,
  //   },
  //   {
  //     id: 114,
  //     name: "eagan",
  //     state: "mn",
  //     population: 68855,
  //     latitude: 44.8155,
  //     longitude: -93.1677,
  //   },
  //   {
  //     id: 115,
  //     name: "east new york",
  //     state: "ny",
  //     population: 200293,
  //     latitude: 40.6695,
  //     longitude: -73.8705,
  //   },
  //   {
  //     id: 116,
  //     name: "east orange",
  //     state: "nj",
  //     population: 68673,
  //     latitude: 40.7787,
  //     longitude: -74.2057,
  //   },
  //   {
  //     id: 117,
  //     name: "edina",
  //     state: "mn",
  //     population: 53000,
  //     latitude: 44.8967,
  //     longitude: -93.3519,
  //   },
  //   {
  //     id: 118,
  //     name: "edison",
  //     state: "nj",
  //     population: 107588,
  //     latitude: 40.5229,
  //     longitude: -74.4172,
  //   },
  //   {
  //     id: 119,
  //     name: "edinburg",
  //     state: "tx",
  //     population: 104046,
  //     latitude: 26.304,
  //     longitude: -98.1633,
  //   },
  //   {
  //     id: 120,
  //     name: "elgin",
  //     state: "il",
  //     population: 114797,
  //     latitude: 42.0392,
  //     longitude: -88.2812,
  //   },
  //   {
  //     id: 121,
  //     name: "el monte",
  //     state: "ca",
  //     population: 109280,
  //     latitude: 34.0689,
  //     longitude: -118.0284,
  //   },
  //   {
  //     id: 122,
  //     name: "el paso",
  //     state: "tx",
  //     population: 681723,
  //     latitude: 31.7619,
  //     longitude: -106.485,
  //   },
  //   {
  //     id: 123,
  //     name: "elk grove",
  //     state: "ca",
  //     population: 161007,
  //     latitude: 38.4088,
  //     longitude: -121.3725,
  //   },
  //   {
  //     id: 124,
  //     name: "elizabeth",
  //     state: "nj",
  //     population: 128315,
  //     latitude: 40.6668,
  //     longitude: -74.2152,
  //   },
  //   {
  //     id: 125,
  //     name: "erie",
  //     state: "pa",
  //     population: 101786,
  //     latitude: 42.1292,
  //     longitude: -80.0851,
  //   },
  //   {
  //     id: 126,
  //     name: "escondido",
  //     state: "ca",
  //     population: 151833,
  //     latitude: 33.1192,
  //     longitude: -117.0864,
  //   },
  //   {
  //     id: 127,
  //     name: "eugene",
  //     state: "or",
  //     population: 159190,
  //     latitude: 44.0521,
  //     longitude: -123.0868,
  //   },
  //   {
  //     id: 128,
  //     name: "evanston",
  //     state: "il",
  //     population: 77800,
  //     latitude: 42.0451,
  //     longitude: -87.6877,
  //   },
  //   {
  //     id: 129,
  //     name: "everett",
  //     state: "ma",
  //     population: 49000,
  //     latitude: 42.4084,
  //     longitude: -71.0695,
  //   },
  //   {
  //     id: 130,
  //     name: "fairfield",
  //     state: "ca",
  //     population: 116223,
  //     latitude: 38.2494,
  //     longitude: -122.0394,
  //   },
  //   {
  //     id: 131,
  //     name: "fall river",
  //     state: "ma",
  //     population: 94002,
  //     latitude: 41.7015,
  //     longitude: -71.1558,
  //   },
  //   {
  //     id: 132,
  //     name: "fargo",
  //     state: "nd",
  //     population: 105549,
  //     latitude: 46.8772,
  //     longitude: -96.7898,
  //   },
  //   {
  //     id: 133,
  //     name: "farmington hills",
  //     state: "mi",
  //     population: 83935,
  //     latitude: 42.4834,
  //     longitude: -83.3769,
  //   },
  //   {
  //     id: 134,
  //     name: "fayetteville",
  //     state: "nc",
  //     population: 204408,
  //     latitude: 35.052,
  //     longitude: -78.8784,
  //   },
  //   {
  //     id: 135,
  //     name: "fayetteville",
  //     state: "ar",
  //     population: 93949,
  //     latitude: 36.0626,
  //     longitude: -94.1574,
  //   },
  //   {
  //     id: 136,
  //     name: "flatbush",
  //     state: "ny",
  //     population: 164568,
  //     latitude: 40.6409,
  //     longitude: -73.9573,
  //   },
  //   {
  //     id: 137,
  //     name: "flint",
  //     state: "mi",
  //     population: 81252,
  //     latitude: 43.0125,
  //     longitude: -83.6875,
  //   },
  //   {
  //     id: 138,
  //     name: "florence",
  //     state: "ky",
  //     population: 30000,
  //     latitude: 38.9965,
  //     longitude: -84.62,
  //   },
  //   {
  //     id: 139,
  //     name: "flower mound",
  //     state: "tx",
  //     population: 78775,
  //     latitude: 33.0298,
  //     longitude: -97.0864,
  //   },
  //   {
  //     id: 140,
  //     name: "flushing",
  //     state: "ny",
  //     population: 170000,
  //     latitude: 40.7592,
  //     longitude: -73.8344,
  //   },
  //   {
  //     id: 141,
  //     name: "fontana",
  //     state: "ca",
  //     population: 214950,
  //     latitude: 34.0928,
  //     longitude: -117.4355,
  //   },
  //   {
  //     id: 142,
  //     name: "forest hills",
  //     state: "ny",
  //     population: 83000,
  //     latitude: 40.7196,
  //     longitude: -73.8447,
  //   },
  //   {
  //     id: 143,
  //     name: "fort collins",
  //     state: "co",
  //     population: 152061,
  //     latitude: 40.5853,
  //     longitude: -105.0844,
  //   },
  //   {
  //     id: 144,
  //     name: "fort lauderdale",
  //     state: "fl",
  //     population: 182760,
  //     latitude: 26.1224,
  //     longitude: -80.1373,
  //   },
  //   {
  //     id: 145,
  //     name: "fort wayne",
  //     state: "in",
  //     population: 269994,
  //     latitude: 41.0792,
  //     longitude: -85.1394,
  //   },
  //   {
  //     id: 146,
  //     name: "fort worth",
  //     state: "tx",
  //     population: 1008106,
  //     latitude: 32.7555,
  //     longitude: -97.33,
  //   },
  //   {
  //     id: 147,
  //     name: "framingham",
  //     state: "ma",
  //     population: 72390,
  //     latitude: 42.2798,
  //     longitude: -71.4162,
  //   },
  //   {
  //     id: 148,
  //     name: "fremont",
  //     state: "ca",
  //     population: 230504,
  //     latitude: 37.5483,
  //     longitude: -121.9886,
  //   },
  //   {
  //     id: 149,
  //     name: "fresno",
  //     state: "ca",
  //     population: 550105,
  //     latitude: 36.7378,
  //     longitude: -119.7871,
  //   },
  //   {
  //     id: 150,
  //     name: "frisco",
  //     state: "tx",
  //     population: 219711,
  //     latitude: 33.1091,
  //     longitude: -96.8239,
  //   },
  //   {
  //     id: 151,
  //     name: "fullerton",
  //     state: "ca",
  //     population: 141870,
  //     latitude: 33.8704,
  //     longitude: -117.925,
  //   },
  //   {
  //     id: 152,
  //     name: "gainesville",
  //     state: "fl",
  //     population: 145214,
  //     latitude: 29.6516,
  //     longitude: -82.3248,
  //   },
  //   {
  //     id: 153,
  //     name: "garden grove",
  //     state: "ca",
  //     population: 171926,
  //     latitude: 33.7739,
  //     longitude: -117.9351,
  //   },
  //   {
  //     id: 154,
  //     name: "gardena",
  //     state: "ca",
  //     population: 60980,
  //     latitude: 33.8828,
  //     longitude: -118.307,
  //   },
  //   {
  //     id: 155,
  //     name: "garland",
  //     state: "tx",
  //     population: 243470,
  //     latitude: 32.9129,
  //     longitude: -96.6417,
  //   },
  //   {
  //     id: 156,
  //     name: "gastonia",
  //     state: "nc",
  //     population: 84666,
  //     latitude: 35.2635,
  //     longitude: -81.1873,
  //   },
  //   {
  //     id: 157,
  //     name: "georgetown",
  //     state: "tx",
  //     population: 101344,
  //     latitude: 30.633,
  //     longitude: -97.6778,
  //   },
  //   {
  //     id: 158,
  //     name: "gilbert",
  //     state: "az",
  //     population: 275411,
  //     latitude: 33.3528,
  //     longitude: -111.789,
  //   },
  //   {
  //     id: 159,
  //     name: "glendale",
  //     state: "az",
  //     population: 253855,
  //     latitude: 33.5386,
  //     longitude: -112.1888,
  //   },
  //   {
  //     id: 160,
  //     name: "glendale",
  //     state: "ca",
  //     population: 196021,
  //     latitude: 34.1425,
  //     longitude: -118.2551,
  //   },
  //   {
  //     id: 161,
  //     name: "grand prairie",
  //     state: "tx",
  //     population: 183372,
  //     latitude: 32.7401,
  //     longitude: -97.0094,
  //   },
  //   {
  //     id: 162,
  //     name: "grand rapids",
  //     state: "mi",
  //     population: 217435,
  //     latitude: 42.9634,
  //     longitude: -85.6681,
  //   },
  //   {
  //     id: 163,
  //     name: "great falls",
  //     state: "mt",
  //     population: 60442,
  //     latitude: 47.5029,
  //     longitude: -111.3009,
  //   },
  //   {
  //     id: 164,
  //     name: "greenpoint",
  //     state: "ny",
  //     population: 204125,
  //     latitude: 40.7359,
  //     longitude: -73.9535,
  //   },
  //   {
  //     id: 165,
  //     name: "greensboro",
  //     state: "nc",
  //     population: 302296,
  //     latitude: 36.0726,
  //     longitude: -79.7919,
  //   },
  //   {
  //     id: 166,
  //     name: "greenwich village",
  //     state: "ny",
  //     population: 30000,
  //     latitude: 40.7306,
  //     longitude: -74.0003,
  //   },
  //   {
  //     id: 167,
  //     name: "gresham",
  //     state: "or",
  //     population: 105594,
  //     latitude: 45.4915,
  //     longitude: -122.4334,
  //   },
  //   {
  //     id: 168,
  //     name: "hamilton",
  //     state: "nj",
  //     population: 92297,
  //     latitude: 40.2312,
  //     longitude: -74.6854,
  //   },
  //   {
  //     id: 169,
  //     name: "hampton",
  //     state: "va",
  //     population: 137452,
  //     latitude: 37.0298,
  //     longitude: -76.3459,
  //   },
  //   {
  //     id: 170,
  //     name: "harlem",
  //     state: "ny",
  //     population: 200000,
  //     latitude: 40.8128,
  //     longitude: -73.9458,
  //   },
  //   {
  //     id: 171,
  //     name: "hartford",
  //     state: "ct",
  //     population: 121054,
  //     latitude: 41.7658,
  //     longitude: -72.6734,
  //   },
  //   {
  //     id: 172,
  //     name: "hayward",
  //     state: "ca",
  //     population: 162954,
  //     latitude: 37.6688,
  //     longitude: -122.0808,
  //   },
  //   {
  //     id: 173,
  //     name: "henderson",
  //     state: "nv",
  //     population: 337305,
  //     latitude: 36.0396,
  //     longitude: -114.9817,
  //   },
  //   {
  //     id: 174,
  //     name: "herndon",
  //     state: "va",
  //     population: 24962,
  //     latitude: 38.9698,
  //     longitude: -77.3875,
  //   },
  //   {
  //     id: 175,
  //     name: "hialeah",
  //     state: "fl",
  //     population: 233394,
  //     latitude: 25.8576,
  //     longitude: -80.2781,
  //   },
  //   {
  //     id: 176,
  //     name: "high point",
  //     state: "nc",
  //     population: 104371,
  //     latitude: 35.9554,
  //     longitude: -79.9928,
  //   },
  //   {
  //     id: 177,
  //     name: "hollywood",
  //     state: "fl",
  //     population: 153067,
  //     latitude: 26.0112,
  //     longitude: -80.1416,
  //   },
  //   {
  //     id: 178,
  //     name: "honolulu",
  //     state: "hi",
  //     population: 395327,
  //     latitude: 21.3069,
  //     longitude: -157.8583,
  //   },
  //   {
  //     id: 179,
  //     name: "houston",
  //     state: "tx",
  //     population: 2390125,
  //     latitude: 29.7604,
  //     longitude: -95.3698,
  //   },
  //   {
  //     id: 180,
  //     name: "huntington beach",
  //     state: "ca",
  //     population: 196947,
  //     latitude: 33.6601,
  //     longitude: -118.0055,
  //   },
  //   {
  //     id: 181,
  //     name: "huntsville",
  //     state: "al",
  //     population: 186254,
  //     latitude: 34.7304,
  //     longitude: -86.5861,
  //   },
  //   {
  //     id: 182,
  //     name: "independence",
  //     state: "mo",
  //     population: 123000,
  //     latitude: 39.0911,
  //     longitude: -94.4158,
  //   },
  //   {
  //     id: 183,
  //     name: "indianapolis",
  //     state: "in",
  //     population: 891484,
  //     latitude: 39.7684,
  //     longitude: -86.158,
  //   },
  //   {
  //     id: 184,
  //     name: "inglewood",
  //     state: "ca",
  //     population: 107762,
  //     latitude: 33.9616,
  //     longitude: -118.3531,
  //   },
  //   {
  //     id: 185,
  //     name: "iowa city",
  //     state: "ia",
  //     population: 76710,
  //     latitude: 41.6611,
  //     longitude: -91.5302,
  //   },
  //   {
  //     id: 186,
  //     name: "irvine",
  //     state: "ca",
  //     population: 314621,
  //     latitude: 33.6846,
  //     longitude: -117.8265,
  //   },
  //   {
  //     id: 187,
  //     name: "irving",
  //     state: "tx",
  //     population: 254373,
  //     latitude: 32.814,
  //     longitude: -96.9489,
  //   },
  //   {
  //     id: 188,
  //     name: "jackson",
  //     state: "ms",
  //     population: 172638,
  //     latitude: 32.2988,
  //     longitude: -90.1848,
  //   },
  //   {
  //     id: 189,
  //     name: "jackson heights",
  //     state: "ny",
  //     population: 100000,
  //     latitude: 40.7686,
  //     longitude: -73.8829,
  //   },
  //   {
  //     id: 190,
  //     name: "jacksonville",
  //     state: "fl",
  //     population: 1009833,
  //     latitude: 30.3322,
  //     longitude: -81.6557,
  //   },
  //   {
  //     id: 191,
  //     name: "jersey city",
  //     state: "nj",
  //     population: 291657,
  //     latitude: 40.7282,
  //     longitude: -74.0776,
  //   },
  //   {
  //     id: 192,
  //     name: "joliet",
  //     state: "il",
  //     population: 150362,
  //     latitude: 41.5255,
  //     longitude: -87.9839,
  //   },
  //   {
  //     id: 193,
  //     name: "kalamazoo",
  //     state: "mi",
  //     population: 73259,
  //     latitude: 42.2917,
  //     longitude: -85.5872,
  //   },
  //   {
  //     id: 194,
  //     name: "kansas city",
  //     state: "mo",
  //     population: 510704,
  //     latitude: 39.0997,
  //     longitude: -94.5786,
  //   },
  //   {
  //     id: 195,
  //     name: "kentwood",
  //     state: "mi",
  //     population: 54629,
  //     latitude: 42.8797,
  //     longitude: -85.6025,
  //   },
  //   {
  //     id: 196,
  //     name: "killeen",
  //     state: "tx",
  //     population: 153095,
  //     latitude: 31.1177,
  //     longitude: -97.7289,
  //   },
  //   {
  //     id: 197,
  //     name: "kissimmee",
  //     state: "fl",
  //     population: 80942,
  //     latitude: 28.2919,
  //     longitude: -81.4078,
  //   },
  //   {
  //     id: 198,
  //     name: "knoxville",
  //     state: "tn",
  //     population: 183270,
  //     latitude: 35.9606,
  //     longitude: -83.9207,
  //   },
  //   {
  //     id: 199,
  //     name: "lakeland",
  //     state: "fl",
  //     population: 115291,
  //     latitude: 28.0395,
  //     longitude: -81.9498,
  //   },
  //   {
  //     id: 200,
  //     name: "lakeville",
  //     state: "mn",
  //     population: 72477,
  //     latitude: 44.6469,
  //     longitude: -93.243,
  //   },
  //   {
  //     id: 201,
  //     name: "lakewood",
  //     state: "co",
  //     population: 155462,
  //     latitude: 39.7047,
  //     longitude: -105.0814,
  //   },
  //   {
  //     id: 202,
  //     name: "lakewood",
  //     state: "nj",
  //     population: 102432,
  //     latitude: 40.091,
  //     longitude: -74.2229,
  //   },
  //   {
  //     id: 203,
  //     name: "lancaster",
  //     state: "ca",
  //     population: 159523,
  //     latitude: 34.6867,
  //     longitude: -118.1548,
  //   },
  //   {
  //     id: 204,
  //     name: "lancaster",
  //     state: "pa",
  //     population: 58000,
  //     latitude: 40.0379,
  //     longitude: -76.3055,
  //   },
  //   {
  //     id: 205,
  //     name: "lansing",
  //     state: "mi",
  //     population: 115291,
  //     latitude: 42.7325,
  //     longitude: -84.5555,
  //   },
  //   {
  //     id: 206,
  //     name: "laredo",
  //     state: "tx",
  //     population: 257602,
  //     latitude: 27.5064,
  //     longitude: -99.4975,
  //   },
  //   {
  //     id: 207,
  //     name: "las vegas",
  //     state: "nv",
  //     population: 678922,
  //     latitude: 36.1716,
  //     longitude: -115.1391,
  //   },
  //   {
  //     id: 208,
  //     name: "lawrence",
  //     state: "ma",
  //     population: 90700,
  //     latitude: 42.707,
  //     longitude: -71.1639,
  //   },
  //   {
  //     id: 209,
  //     name: "league city",
  //     state: "tx",
  //     population: 117765,
  //     latitude: 29.5077,
  //     longitude: -95.0744,
  //   },
  //   {
  //     id: 210,
  //     name: "leesburg",
  //     state: "va",
  //     population: 49000,
  //     latitude: 39.1143,
  //     longitude: -77.5604,
  //   },
  //   {
  //     id: 211,
  //     name: "lewisville",
  //     state: "tx",
  //     population: 114883,
  //     latitude: 33.0457,
  //     longitude: -97.0053,
  //   },
  //   {
  //     id: 212,
  //     name: "lexington",
  //     state: "ky",
  //     population: 320154,
  //     latitude: 38.0406,
  //     longitude: -84.5037,
  //   },
  //   {
  //     id: 213,
  //     name: "lincoln",
  //     state: "ne",
  //     population: 294757,
  //     latitude: 40.8136,
  //     longitude: -96.7026,
  //   },
  //   {
  //     id: 214,
  //     name: "little rock",
  //     state: "ar",
  //     population: 204481,
  //     latitude: 34.7465,
  //     longitude: -92.2896,
  //   },
  //   {
  //     id: 215,
  //     name: "livonia",
  //     state: "mi",
  //     population: 91873,
  //     latitude: 42.3642,
  //     longitude: -83.3769,
  //   },
  //   {
  //     id: 216,
  //     name: "long beach",
  //     state: "ca",
  //     population: 449468,
  //     latitude: 33.7701,
  //     longitude: -118.1937,
  //   },
  //   {
  //     id: 217,
  //     name: "long island city",
  //     state: "ny",
  //     population: 100000,
  //     latitude: 40.7447,
  //     longitude: -73.9485,
  //   },
  //   {
  //     id: 218,
  //     name: "longview",
  //     state: "tx",
  //     population: 81000,
  //     latitude: 32.5029,
  //     longitude: -94.7408,
  //   },
  //   {
  //     id: 219,
  //     name: "los angeles",
  //     state: "ca",
  //     population: 3878704,
  //     latitude: 34.0522,
  //     longitude: -118.2437,
  //   },
  //   {
  //     id: 220,
  //     name: "louisville/jefferson county",
  //     state: "ky",
  //     population: 640796,
  //     latitude: 38.2527,
  //     longitude: -85.7585,
  //   },
  //   {
  //     id: 221,
  //     name: "lower east side",
  //     state: "ny",
  //     population: 163141,
  //     latitude: 40.7148,
  //     longitude: -73.9877,
  //   },
  //   {
  //     id: 222,
  //     name: "lowell",
  //     state: "ma",
  //     population: 115554,
  //     latitude: 42.6397,
  //     longitude: -71.363,
  //   },
  //   {
  //     id: 223,
  //     name: "lubbock",
  //     state: "tx",
  //     population: 266878,
  //     latitude: 33.5779,
  //     longitude: -101.8552,
  //   },
  //   {
  //     id: 224,
  //     name: "lynchburg",
  //     state: "va",
  //     population: 80687,
  //     latitude: 37.4046,
  //     longitude: -79.1437,
  //   },
  //   {
  //     id: 225,
  //     name: "lynn",
  //     state: "ma",
  //     population: 101253,
  //     latitude: 42.4668,
  //     longitude: -70.9498,
  //   },
  //   {
  //     id: 226,
  //     name: "madison",
  //     state: "wi",
  //     population: 280305,
  //     latitude: 43.0731,
  //     longitude: -89.4012,
  //   },
  //   {
  //     id: 227,
  //     name: "malden",
  //     state: "ma",
  //     population: 66907,
  //     latitude: 42.4293,
  //     longitude: -71.0745,
  //   },
  //   {
  //     id: 228,
  //     name: "manchester",
  //     state: "nh",
  //     population: 115644,
  //     latitude: 42.9956,
  //     longitude: -71.4548,
  //   },
  //   {
  //     id: 229,
  //     name: "manhattan",
  //     state: "ny",
  //     population: 1596273,
  //     latitude: 40.7831,
  //     longitude: -73.9712,
  //   },
  //   {
  //     id: 230,
  //     name: "mansfield",
  //     state: "tx",
  //     population: 75000,
  //     latitude: 32.5646,
  //     longitude: -97.1408,
  //   },
  //   {
  //     id: 231,
  //     name: "maple grove",
  //     state: "mn",
  //     population: 70919,
  //     latitude: 45.0869,
  //     longitude: -93.4475,
  //   },
  //   {
  //     id: 232,
  //     name: "mclean",
  //     state: "va",
  //     population: 48115,
  //     latitude: 38.9334,
  //     longitude: -77.1772,
  //   },
  //   {
  //     id: 233,
  //     name: "medford",
  //     state: "ma",
  //     population: 60000,
  //     latitude: 42.4176,
  //     longitude: -71.1062,
  //   },
  //   {
  //     id: 234,
  //     name: "melbourne",
  //     state: "fl",
  //     population: 84678,
  //     latitude: 28.0837,
  //     longitude: -80.6087,
  //   },
  //   {
  //     id: 235,
  //     name: "memphis",
  //     state: "tn",
  //     population: 610919,
  //     latitude: 35.1495,
  //     longitude: -90.049,
  //   },
  //   {
  //     id: 236,
  //     name: "menifee",
  //     state: "ca",
  //     population: 108398,
  //     latitude: 33.7259,
  //     longitude: -117.1706,
  //   },
  //   {
  //     id: 237,
  //     name: "meridian",
  //     state: "id",
  //     population: 133446,
  //     latitude: 43.612,
  //     longitude: -116.3915,
  //   },
  //   {
  //     id: 238,
  //     name: "mesa",
  //     state: "az",
  //     population: 504258,
  //     latitude: 33.4148,
  //     longitude: -111.9079,
  //   },
  //   {
  //     id: 239,
  //     name: "mesquite",
  //     state: "tx",
  //     population: 150938,
  //     latitude: 32.7951,
  //     longitude: -96.5983,
  //   },
  //   {
  //     id: 240,
  //     name: "metairie",
  //     state: "la",
  //     population: 138481,
  //     latitude: 29.983,
  //     longitude: -90.1558,
  //   },
  //   {
  //     id: 241,
  //     name: "miami",
  //     state: "fl",
  //     population: 455924,
  //     latitude: 25.7617,
  //     longitude: -80.1918,
  //   },
  //   {
  //     id: 242,
  //     name: "miami gardens",
  //     state: "fl",
  //     population: 112015,
  //     latitude: 25.9423,
  //     longitude: -80.2439,
  //   },
  //   {
  //     id: 243,
  //     name: "midland",
  //     state: "tx",
  //     population: 132479,
  //     latitude: 31.9974,
  //     longitude: -102.0779,
  //   },
  //   {
  //     id: 244,
  //     name: "midlothian",
  //     state: "va",
  //     population: 66072,
  //     latitude: 37.4735,
  //     longitude: -77.6534,
  //   },
  //   {
  //     id: 245,
  //     name: "midtown",
  //     state: "ny",
  //     population: 63600,
  //     latitude: 40.7592,
  //     longitude: -73.9846,
  //   },
  //   {
  //     id: 246,
  //     name: "milwaukee",
  //     state: "wi",
  //     population: 563531,
  //     latitude: 43.0389,
  //     longitude: -87.9065,
  //   },
  //   {
  //     id: 247,
  //     name: "minneapolis",
  //     state: "mn",
  //     population: 425115,
  //     latitude: 44.9778,
  //     longitude: -93.265,
  //   },
  //   {
  //     id: 248,
  //     name: "miramar",
  //     state: "fl",
  //     population: 137452,
  //     latitude: 25.9604,
  //     longitude: -80.2317,
  //   },
  //   {
  //     id: 249,
  //     name: "mission",
  //     state: "tx",
  //     population: 86055,
  //     latitude: 26.2167,
  //     longitude: -98.3242,
  //   },
  //   {
  //     id: 250,
  //     name: "missoula",
  //     state: "mt",
  //     population: 76957,
  //     latitude: 46.8721,
  //     longitude: -113.994,
  //   },
  //   {
  //     id: 251,
  //     name: "missouri city",
  //     state: "tx",
  //     population: 77655,
  //     latitude: 29.5855,
  //     longitude: -95.5397,
  //   },
  //   {
  //     id: 252,
  //     name: "mobile",
  //     state: "al",
  //     population: 204368,
  //     latitude: 30.6954,
  //     longitude: -88.0399,
  //   },
  //   {
  //     id: 253,
  //     name: "modesto",
  //     state: "ca",
  //     population: 204933,
  //     latitude: 37.6391,
  //     longitude: -120.9969,
  //   },
  //   {
  //     id: 254,
  //     name: "monroe",
  //     state: "la",
  //     population: 48000,
  //     latitude: 32.5113,
  //     longitude: -92.1207,
  //   },
  //   {
  //     id: 255,
  //     name: "montgomery",
  //     state: "al",
  //     population: 201332,
  //     latitude: 32.3668,
  //     longitude: -86.3006,
  //   },
  //   {
  //     id: 256,
  //     name: "moreno valley",
  //     state: "ca",
  //     population: 208634,
  //     latitude: 33.9425,
  //     longitude: -117.2294,
  //   },
  //   {
  //     id: 257,
  //     name: "murfreesboro",
  //     state: "tn",
  //     population: 162386,
  //     latitude: 35.845,
  //     longitude: -86.39,
  //   },
  //   {
  //     id: 258,
  //     name: "murrieta",
  //     state: "ca",
  //     population: 112117,
  //     latitude: 33.5539,
  //     longitude: -117.2003,
  //   },
  //   {
  //     id: 259,
  //     name: "myrtle beach",
  //     state: "sc",
  //     population: 38166,
  //     latitude: 33.6891,
  //     longitude: -78.8867,
  //   },
  //   {
  //     id: 260,
  //     name: "naperville",
  //     state: "il",
  //     population: 149544,
  //     latitude: 41.7513,
  //     longitude: -88.1549,
  //   },
  //   {
  //     id: 261,
  //     name: "nashua",
  //     state: "nh",
  //     population: 91322,
  //     latitude: 42.7654,
  //     longitude: -71.4678,
  //   },
  //   {
  //     id: 262,
  //     name: "nashville",
  //     state: "tn",
  //     population: 704963,
  //     latitude: 36.1627,
  //     longitude: -86.7816,
  //   },
  //   {
  //     id: 263,
  //     name: "new bedford",
  //     state: "ma",
  //     population: 100918,
  //     latitude: 41.6362,
  //     longitude: -70.9348,
  //   },
  //   {
  //     id: 264,
  //     name: "new braunfels",
  //     state: "tx",
  //     population: 104707,
  //     latitude: 29.7027,
  //     longitude: -98.1242,
  //   },
  //   {
  //     id: 265,
  //     name: "new brunswick",
  //     state: "nj",
  //     population: 56006,
  //     latitude: 40.4862,
  //     longitude: -74.4518,
  //   },
  //   {
  //     id: 266,
  //     name: "new haven",
  //     state: "ct",
  //     population: 134023,
  //     latitude: 41.3083,
  //     longitude: -72.9279,
  //   },
  //   {
  //     id: 267,
  //     name: "new orleans",
  //     state: "la",
  //     population: 364136,
  //     latitude: 29.9511,
  //     longitude: -90.0715,
  //   },
  //   {
  //     id: 268,
  //     name: "new york city",
  //     state: "ny",
  //     population: 8478072,
  //     latitude: 40.7128,
  //     longitude: -74.006,
  //   },
  //   {
  //     id: 269,
  //     name: "newark",
  //     state: "nj",
  //     population: 304960,
  //     latitude: 40.7357,
  //     longitude: -74.1724,
  //   },
  //   {
  //     id: 270,
  //     name: "newport news",
  //     state: "va",
  //     population: 185670,
  //     latitude: 37.0683,
  //     longitude: -76.4172,
  //   },
  //   {
  //     id: 271,
  //     name: "newton",
  //     state: "ma",
  //     population: 88920,
  //     latitude: 42.3361,
  //     longitude: -71.2092,
  //   },
  //   {
  //     id: 272,
  //     name: "norfolk",
  //     state: "va",
  //     population: 230930,
  //     latitude: 36.8508,
  //     longitude: -76.2859,
  //   },
  //   {
  //     id: 273,
  //     name: "normal",
  //     state: "il",
  //     population: 54101,
  //     latitude: 40.5186,
  //     longitude: -89.0062,
  //   },
  //   {
  //     id: 274,
  //     name: "north charleston",
  //     state: "sc",
  //     population: 115312,
  //     latitude: 32.8546,
  //     longitude: -80.0384,
  //   },
  //   {
  //     id: 275,
  //     name: "north las vegas",
  //     state: "nv",
  //     population: 284771,
  //     latitude: 36.2774,
  //     longitude: -115.117,
  //   },
  //   {
  //     id: 276,
  //     name: "norwalk",
  //     state: "ca",
  //     population: 102773,
  //     latitude: 33.9036,
  //     longitude: -118.082,
  //   },
  //   {
  //     id: 277,
  //     name: "oakland",
  //     state: "ca",
  //     population: 436504,
  //     latitude: 37.8044,
  //     longitude: -122.2712,
  //   },
  //   {
  //     id: 278,
  //     name: "oakton",
  //     state: "va",
  //     population: 36561,
  //     latitude: 38.8994,
  //     longitude: -77.3197,
  //   },
  //   {
  //     id: 279,
  //     name: "ocala",
  //     state: "fl",
  //     population: 65123,
  //     latitude: 29.1872,
  //     longitude: -82.1401,
  //   },
  //   {
  //     id: 280,
  //     name: "oceanside",
  //     state: "ca",
  //     population: 172794,
  //     latitude: 33.1959,
  //     longitude: -117.3794,
  //   },
  //   {
  //     id: 281,
  //     name: "odessa",
  //     state: "tx",
  //     population: 125000,
  //     latitude: 31.8457,
  //     longitude: -102.3672,
  //   },
  //   {
  //     id: 282,
  //     name: "oklahoma city",
  //     state: "ok",
  //     population: 712919,
  //     latitude: 35.4676,
  //     longitude: -97.5164,
  //   },
  //   {
  //     id: 283,
  //     name: "omaha",
  //     state: "ne",
  //     population: 483335,
  //     latitude: 41.2565,
  //     longitude: -95.9345,
  //   },
  //   {
  //     id: 284,
  //     name: "ontario",
  //     state: "ca",
  //     population: 167500,
  //     latitude: 34.0633,
  //     longitude: -117.6509,
  //   },
  //   {
  //     id: 285,
  //     name: "orange",
  //     state: "ca",
  //     population: 138676,
  //     latitude: 33.7877,
  //     longitude: -117.8531,
  //   },
  //   {
  //     id: 286,
  //     name: "orlando",
  //     state: "fl",
  //     population: 320742,
  //     latitude: 28.5383,
  //     longitude: -81.3792,
  //   },
  //   {
  //     id: 287,
  //     name: "overland park",
  //     state: "ks",
  //     population: 197825,
  //     latitude: 38.9822,
  //     longitude: -94.6708,
  //   },
  //   {
  //     id: 288,
  //     name: "oxnard",
  //     state: "ca",
  //     population: 203007,
  //     latitude: 34.197,
  //     longitude: -119.1774,
  //   },
  //   {
  //     id: 289,
  //     name: "palatine",
  //     state: "il",
  //     population: 69324,
  //     latitude: 42.1003,
  //     longitude: -88.0495,
  //   },
  //   {
  //     id: 290,
  //     name: "palmdale",
  //     state: "ca",
  //     population: 157161,
  //     latitude: 34.5936,
  //     longitude: -118.1145,
  //   },
  //   {
  //     id: 291,
  //     name: "pasadena",
  //     state: "ca",
  //     population: 139174,
  //     latitude: 34.1478,
  //     longitude: -118.1445,
  //   },
  //   {
  //     id: 292,
  //     name: "pasadena",
  //     state: "tx",
  //     population: 152735,
  //     latitude: 29.688,
  //     longitude: -95.2077,
  //   },
  //   {
  //     id: 293,
  //     name: "passaic",
  //     state: "nj",
  //     population: 70557,
  //     latitude: 40.8562,
  //     longitude: -74.1207,
  //   },
  //   {
  //     id: 294,
  //     name: "paterson",
  //     state: "nj",
  //     population: 159732,
  //     latitude: 40.9167,
  //     longitude: -74.1717,
  //   },
  //   {
  //     id: 295,
  //     name: "pearland",
  //     state: "tx",
  //     population: 129486,
  //     latitude: 29.563,
  //     longitude: -95.2677,
  //   },
  //   {
  //     id: 296,
  //     name: "pembroke pines",
  //     state: "fl",
  //     population: 162329,
  //     latitude: 26.0076,
  //     longitude: -80.284,
  //   },
  //   {
  //     id: 297,
  //     name: "pensacola",
  //     state: "fl",
  //     population: 54139,
  //     latitude: 30.4213,
  //     longitude: -87.2169,
  //   },
  //   {
  //     id: 298,
  //     name: "peoria",
  //     state: "az",
  //     population: 162592,
  //     latitude: 33.5806,
  //     longitude: -112.231,
  //   },
  //   {
  //     id: 299,
  //     name: "peoria",
  //     state: "il",
  //     population: 113101,
  //     latitude: 40.6936,
  //     longitude: -89.5889,
  //   },
  //   {
  //     id: 300,
  //     name: "pharr",
  //     state: "tx",
  //     population: 82061,
  //     latitude: 26.2167,
  //     longitude: -98.1814,
  //   },
  //   {
  //     id: 301,
  //     name: "philadelphia",
  //     state: "pa",
  //     population: 1573916,
  //     latitude: 39.9526,
  //     longitude: -75.1652,
  //   },
  //   {
  //     id: 302,
  //     name: "phoenix",
  //     state: "az",
  //     population: 1673164,
  //     latitude: 33.4484,
  //     longitude: -112.074,
  //   },
  //   {
  //     id: 303,
  //     name: "pittsburgh",
  //     state: "pa",
  //     population: 303255,
  //     latitude: 40.4406,
  //     longitude: -79.9959,
  //   },
  //   {
  //     id: 304,
  //     name: "plantation",
  //     state: "fl",
  //     population: 100694,
  //     latitude: 26.1287,
  //     longitude: -80.2392,
  //   },
  //   {
  //     id: 305,
  //     name: "plano",
  //     state: "tx",
  //     population: 290190,
  //     latitude: 33.0198,
  //     longitude: -96.6989,
  //   },
  //   {
  //     id: 306,
  //     name: "plymouth",
  //     state: "ma",
  //     population: 60462,
  //     latitude: 41.9584,
  //     longitude: -70.6675,
  //   },
  //   {
  //     id: 307,
  //     name: "plymouth",
  //     state: "mn",
  //     population: 81093,
  //     latitude: 45.0069,
  //     longitude: -93.4547,
  //   },
  //   {
  //     id: 308,
  //     name: "pomona",
  //     state: "ca",
  //     population: 153120,
  //     latitude: 34.0559,
  //     longitude: -117.7508,
  //   },
  //   {
  //     id: 309,
  //     name: "pompano beach",
  //     state: "fl",
  //     population: 113106,
  //     latitude: 26.2365,
  //     longitude: -80.1245,
  //   },
  //   {
  //     id: 310,
  //     name: "pontiac",
  //     state: "mi",
  //     population: 60573,
  //     latitude: 42.6389,
  //     longitude: -83.2927,
  //   },
  //   {
  //     id: 311,
  //     name: "port st. lucie",
  //     state: "fl",
  //     population: 245021,
  //     latitude: 27.2936,
  //     longitude: -80.3259,
  //   },
  //   {
  //     id: 312,
  //     name: "portland",
  //     state: "or",
  //     population: 635749,
  //     latitude: 45.5051,
  //     longitude: -122.675,
  //   },
  //   {
  //     id: 313,
  //     name: "portsmouth",
  //     state: "va",
  //     population: 99195,
  //     latitude: 36.8354,
  //     longitude: -76.2989,
  //   },
  //   {
  //     id: 314,
  //     name: "providence",
  //     state: "ri",
  //     population: 190934,
  //     latitude: 41.824,
  //     longitude: -71.4128,
  //   },
  //   {
  //     id: 315,
  //     name: "pueblo",
  //     state: "co",
  //     population: 103495,
  //     latitude: 38.2545,
  //     longitude: -104.6091,
  //   },
  //   {
  //     id: 316,
  //     name: "quincy",
  //     state: "ma",
  //     population: 100000,
  //     latitude: 42.2529,
  //     longitude: -71.0023,
  //   },
  //   {
  //     id: 317,
  //     name: "queens",
  //     state: "ny",
  //     population: 2277638,
  //     latitude: 40.7282,
  //     longitude: -73.7949,
  //   },
  //   {
  //     id: 318,
  //     name: "raleigh",
  //     state: "nc",
  //     population: 482295,
  //     latitude: 35.7796,
  //     longitude: -78.6382,
  //   },
  //   {
  //     id: 319,
  //     name: "rancho cucamonga",
  //     state: "ca",
  //     population: 171386,
  //     latitude: 34.103,
  //     longitude: -117.5928,
  //   },
  //   {
  //     id: 320,
  //     name: "reading",
  //     state: "pa",
  //     population: 95112,
  //     latitude: 40.3356,
  //     longitude: -75.9269,
  //   },
  //   {
  //     id: 321,
  //     name: "redding",
  //     state: "ca",
  //     population: 93611,
  //     latitude: 40.5865,
  //     longitude: -122.3917,
  //   },
  //   {
  //     id: 322,
  //     name: "reno",
  //     state: "nv",
  //     population: 274915,
  //     latitude: 39.5296,
  //     longitude: -119.8138,
  //   },
  //   {
  //     id: 323,
  //     name: "renton",
  //     state: "wa",
  //     population: 106967,
  //     latitude: 47.4898,
  //     longitude: -122.2117,
  //   },
  //   {
  //     id: 324,
  //     name: "reston",
  //     state: "va",
  //     population: 63229,
  //     latitude: 38.9647,
  //     longitude: -77.3559,
  //   },
  //   {
  //     id: 325,
  //     name: "revere",
  //     state: "ma",
  //     population: 62186,
  //     latitude: 42.4084,
  //     longitude: -71.0906,
  //   },
  //   {
  //     id: 326,
  //     name: "rialto",
  //     state: "ca",
  //     population: 104026,
  //     latitude: 34.1064,
  //     longitude: -117.382,
  //   },
  //   {
  //     id: 327,
  //     name: "richardson",
  //     state: "tx",
  //     population: 119469,
  //     latitude: 32.9483,
  //     longitude: -96.7297,
  //   },
  //   {
  //     id: 328,
  //     name: "richmond",
  //     state: "ca",
  //     population: 115456,
  //     latitude: 37.9358,
  //     longitude: -122.3473,
  //   },
  //   {
  //     id: 329,
  //     name: "richmond",
  //     state: "va",
  //     population: 229247,
  //     latitude: 37.5407,
  //     longitude: -77.436,
  //   },
  //   {
  //     id: 330,
  //     name: "rio rancho",
  //     state: "nm",
  //     population: 104046,
  //     latitude: 35.2348,
  //     longitude: -106.6661,
  //   },
  //   {
  //     id: 331,
  //     name: "riverdale",
  //     state: "ny",
  //     population: 48000,
  //     latitude: 40.8929,
  //     longitude: -73.9067,
  //   },
  //   {
  //     id: 332,
  //     name: "riverside",
  //     state: "ca",
  //     population: 318858,
  //     latitude: 33.9806,
  //     longitude: -117.3755,
  //   },
  //   {
  //     id: 333,
  //     name: "roanoke",
  //     state: "va",
  //     population: 100000,
  //     latitude: 37.2709,
  //     longitude: -79.9415,
  //   },
  //   {
  //     id: 334,
  //     name: "rochester",
  //     state: "mn",
  //     population: 121966,
  //     latitude: 44.0203,
  //     longitude: -92.469,
  //   },
  //   {
  //     id: 335,
  //     name: "rochester",
  //     state: "ny",
  //     population: 210358,
  //     latitude: 43.1566,
  //     longitude: -77.6088,
  //   },
  //   {
  //     id: 336,
  //     name: "rockford",
  //     state: "il",
  //     population: 147604,
  //     latitude: 42.2711,
  //     longitude: -89.0969,
  //   },
  //   {
  //     id: 337,
  //     name: "roseville",
  //     state: "ca",
  //     population: 150000,
  //     latitude: 38.7527,
  //     longitude: -121.2847,
  //   },
  //   {
  //     id: 338,
  //     name: "roswell",
  //     state: "ga",
  //     population: 93000,
  //     latitude: 34.027,
  //     longitude: -84.3611,
  //   },
  //   {
  //     id: 339,
  //     name: "roswell",
  //     state: "nm",
  //     population: 47915,
  //     latitude: 33.3942,
  //     longitude: -104.5222,
  //   },
  //   {
  //     id: 340,
  //     name: "round rock",
  //     state: "tx",
  //     population: 130000,
  //     latitude: 30.5083,
  //     longitude: -97.6789,
  //   },
  //   {
  //     id: 341,
  //     name: "rowlett",
  //     state: "tx",
  //     population: 65000,
  //     latitude: 32.9037,
  //     longitude: -96.5886,
  //   },
  //   {
  //     id: 342,
  //     name: "royal oak",
  //     state: "mi",
  //     population: 58652,
  //     latitude: 42.4895,
  //     longitude: -83.1444,
  //   },
  //   {
  //     id: 343,
  //     name: "sacramento",
  //     state: "ca",
  //     population: 535798,
  //     latitude: 38.5816,
  //     longitude: -121.4944,
  //   },
  //   {
  //     id: 344,
  //     name: "saginaw",
  //     state: "mi",
  //     population: 44202,
  //     latitude: 43.4192,
  //     longitude: -83.945,
  //   },
  //   {
  //     id: 345,
  //     name: "salem",
  //     state: "or",
  //     population: 160614,
  //     latitude: 44.9429,
  //     longitude: -123.0351,
  //   },
  //   {
  //     id: 346,
  //     name: "salinas",
  //     state: "ca",
  //     population: 155662,
  //     latitude: 36.6777,
  //     longitude: -121.6555,
  //   },
  //   {
  //     id: 347,
  //     name: "salt lake city",
  //     state: "ut",
  //     population: 191180,
  //     latitude: 40.7608,
  //     longitude: -111.891,
  //   },
  //   {
  //     id: 348,
  //     name: "san angelo",
  //     state: "tx",
  //     population: 100159,
  //     latitude: 31.4638,
  //     longitude: -100.437,
  //   },
  //   {
  //     id: 349,
  //     name: "san antonio",
  //     state: "tx",
  //     population: 1526656,
  //     latitude: 29.4241,
  //     longitude: -98.4936,
  //   },
  //   {
  //     id: 350,
  //     name: "san bernardino",
  //     state: "ca",
  //     population: 222101,
  //     latitude: 34.1083,
  //     longitude: -117.2898,
  //   },
  //   {
  //     id: 351,
  //     name: "san diego",
  //     state: "ca",
  //     population: 1404452,
  //     latitude: 32.7157,
  //     longitude: -117.1611,
  //   },
  //   {
  //     id: 352,
  //     name: "san francisco",
  //     state: "ca",
  //     population: 827526,
  //     latitude: 37.7749,
  //     longitude: -122.4194,
  //   },
  //   {
  //     id: 353,
  //     name: "san jose",
  //     state: "ca",
  //     population: 997368,
  //     latitude: 37.3382,
  //     longitude: -121.8863,
  //   },
  //   {
  //     id: 354,
  //     name: "san marcos",
  //     state: "tx",
  //     population: 70000,
  //     latitude: 29.8833,
  //     longitude: -97.9412,
  //   },
  //   {
  //     id: 355,
  //     name: "san mateo",
  //     state: "ca",
  //     population: 105803,
  //     latitude: 37.563,
  //     longitude: -122.3255,
  //   },
  //   {
  //     id: 356,
  //     name: "sanford",
  //     state: "fl",
  //     population: 62283,
  //     latitude: 28.8,
  //     longitude: -81.2676,
  //   },
  //   {
  //     id: 357,
  //     name: "santa ana",
  //     state: "ca",
  //     population: 310539,
  //     latitude: 33.7455,
  //     longitude: -117.8677,
  //   },
  //   {
  //     id: 358,
  //     name: "santa clara",
  //     state: "ca",
  //     population: 129033,
  //     latitude: 37.3541,
  //     longitude: -121.9691,
  //   },
  //   {
  //     id: 359,
  //     name: "santa clarita",
  //     state: "ca",
  //     population: 228673,
  //     latitude: 34.3917,
  //     longitude: -118.5498,
  //   },
  //   {
  //     id: 360,
  //     name: "santa fe",
  //     state: "nm",
  //     population: 88193,
  //     latitude: 35.687,
  //     longitude: -105.9375,
  //   },
  //   {
  //     id: 361,
  //     name: "santa monica",
  //     state: "ca",
  //     population: 93000,
  //     latitude: 34.0195,
  //     longitude: -118.4912,
  //   },
  //   {
  //     id: 362,
  //     name: "santa rosa",
  //     state: "ca",
  //     population: 171990,
  //     latitude: 38.4404,
  //     longitude: -122.7141,
  //   },
  //   {
  //     id: 363,
  //     name: "sarasota",
  //     state: "fl",
  //     population: 57000,
  //     latitude: 27.3364,
  //     longitude: -82.5307,
  //   },
  //   {
  //     id: 364,
  //     name: "schaumburg",
  //     state: "il",
  //     population: 77317,
  //     latitude: 42.0334,
  //     longitude: -88.0776,
  //   },
  //   {
  //     id: 365,
  //     name: "scottsdale",
  //     state: "az",
  //     population: 244394,
  //     latitude: 33.4942,
  //     longitude: -111.9261,
  //   },
  //   {
  //     id: 366,
  //     name: "seattle",
  //     state: "wa",
  //     population: 780995,
  //     latitude: 47.6062,
  //     longitude: -122.3321,
  //   },
  //   {
  //     id: 367,
  //     name: "shreveport",
  //     state: "la",
  //     population: 182000,
  //     latitude: 32.5252,
  //     longitude: -93.7502,
  //   },
  //   {
  //     id: 368,
  //     name: "simi valley",
  //     state: "ca",
  //     population: 126938,
  //     latitude: 34.2697,
  //     longitude: -118.7812,
  //   },
  //   {
  //     id: 369,
  //     name: "sioux falls",
  //     state: "sd",
  //     population: 164676,
  //     latitude: 43.546,
  //     longitude: -96.7317,
  //   },
  //   {
  //     id: 370,
  //     name: "skokie",
  //     state: "il",
  //     population: 63934,
  //     latitude: 42.0353,
  //     longitude: -87.7303,
  //   },
  //   {
  //     id: 371,
  //     name: "soho",
  //     state: "ny",
  //     population: 15000,
  //     latitude: 40.7233,
  //     longitude: -74.0028,
  //   },
  //   {
  //     id: 372,
  //     name: "somerville",
  //     state: "ma",
  //     population: 80942,
  //     latitude: 42.3876,
  //     longitude: -71.0995,
  //   },
  //   {
  //     id: 373,
  //     name: "south bend",
  //     state: "in",
  //     population: 101168,
  //     latitude: 41.6834,
  //     longitude: -86.2503,
  //   },
  //   {
  //     id: 374,
  //     name: "southfield",
  //     state: "mi",
  //     population: 78775,
  //     latitude: 42.4834,
  //     longitude: -83.2216,
  //   },
  //   {
  //     id: 375,
  //     name: "spokane",
  //     state: "wa",
  //     population: 229447,
  //     latitude: 47.6587,
  //     longitude: -117.426,
  //   },
  //   {
  //     id: 376,
  //     name: "springfield",
  //     state: "il",
  //     population: 113331,
  //     latitude: 39.799,
  //     longitude: -89.6437,
  //   },
  //   {
  //     id: 377,
  //     name: "springfield",
  //     state: "ma",
  //     population: 153703,
  //     latitude: 42.1015,
  //     longitude: -72.6258,
  //   },
  //   {
  //     id: 378,
  //     name: "springfield",
  //     state: "mo",
  //     population: 215415,
  //     latitude: 37.2154,
  //     longitude: -93.2982,
  //   },
  //   {
  //     id: 379,
  //     name: "st. augustine",
  //     state: "fl",
  //     population: 15152,
  //     latitude: 29.9012,
  //     longitude: -81.3125,
  //   },
  //   {
  //     id: 380,
  //     name: "st. clair shores",
  //     state: "mi",
  //     population: 58212,
  //     latitude: 42.4939,
  //     longitude: -82.898,
  //   },
  //   {
  //     id: 381,
  //     name: "st. cloud",
  //     state: "mn",
  //     population: 68462,
  //     latitude: 45.5576,
  //     longitude: -94.162,
  //   },
  //   {
  //     id: 382,
  //     name: "st. louis",
  //     state: "mo",
  //     population: 281754,
  //     latitude: 38.627,
  //     longitude: -90.1994,
  //   },
  //   {
  //     id: 383,
  //     name: "st. paul",
  //     state: "mn",
  //     population: 303820,
  //     latitude: 44.9537,
  //     longitude: -93.09,
  //   },
  //   {
  //     id: 384,
  //     name: "staten island",
  //     state: "ny",
  //     population: 490687,
  //     latitude: 40.579,
  //     longitude: -74.1515,
  //   },
  //   {
  //     id: 385,
  //     name: "st. petersburg",
  //     state: "fl",
  //     population: 263553,
  //     latitude: 27.7676,
  //     longitude: -82.6403,
  //   },
  //   {
  //     id: 386,
  //     name: "stamford",
  //     state: "ct",
  //     population: 139366,
  //     latitude: 41.0535,
  //     longitude: -73.5487,
  //   },
  //   {
  //     id: 387,
  //     name: "sterling",
  //     state: "va",
  //     population: 27822,
  //     latitude: 39.0068,
  //     longitude: -77.4172,
  //   },
  //   {
  //     id: 388,
  //     name: "sterling heights",
  //     state: "mi",
  //     population: 134375,
  //     latitude: 42.5806,
  //     longitude: -83.0305,
  //   },
  //   {
  //     id: 389,
  //     name: "stockton",
  //     state: "ca",
  //     population: 319543,
  //     latitude: 37.9577,
  //     longitude: -121.2908,
  //   },
  //   {
  //     id: 390,
  //     name: "suffolk",
  //     state: "va",
  //     population: 98664,
  //     latitude: 36.7282,
  //     longitude: -76.5828,
  //   },
  //   {
  //     id: 391,
  //     name: "sugar land",
  //     state: "tx",
  //     population: 111026,
  //     latitude: 29.6195,
  //     longitude: -95.63,
  //   },
  //   {
  //     id: 392,
  //     name: "sunnyvale",
  //     state: "ca",
  //     population: 151806,
  //     latitude: 37.3688,
  //     longitude: -122.0363,
  //   },
  //   {
  //     id: 393,
  //     name: "sunrise",
  //     state: "fl",
  //     population: 100128,
  //     latitude: 26.1554,
  //     longitude: -80.34,
  //   },
  //   {
  //     id: 394,
  //     name: "sunnyside",
  //     state: "ny",
  //     population: 48000,
  //     latitude: 40.7454,
  //     longitude: -73.9248,
  //   },
  //   {
  //     id: 395,
  //     name: "syracuse",
  //     state: "ny",
  //     population: 142327,
  //     latitude: 43.0481,
  //     longitude: -76.1474,
  //   },
  //   {
  //     id: 396,
  //     name: "tacoma",
  //     state: "wa",
  //     population: 203446,
  //     latitude: 47.2529,
  //     longitude: -122.4443,
  //   },
  //   {
  //     id: 397,
  //     name: "tallahassee",
  //     state: "fl",
  //     population: 186411,
  //     latitude: 30.4383,
  //     longitude: -84.2807,
  //   },
  //   {
  //     id: 398,
  //     name: "tampa",
  //     state: "fl",
  //     population: 403364,
  //     latitude: 27.9465,
  //     longitude: -82.4572,
  //   },
  //   {
  //     id: 399,
  //     name: "taunton",
  //     state: "ma",
  //     population: 59000,
  //     latitude: 41.9,
  //     longitude: -71.1,
  //   },
  //   {
  //     id: 400,
  //     name: "taylor",
  //     state: "mi",
  //     population: 63400,
  //     latitude: 42.2281,
  //     longitude: -83.2755,
  //   },
  //   {
  //     id: 401,
  //     name: "temecula",
  //     state: "ca",
  //     population: 111166,
  //     latitude: 33.4914,
  //     longitude: -117.1481,
  //   },
  //   {
  //     id: 402,
  //     name: "tempe",
  //     state: "az",
  //     population: 168228,
  //     latitude: 33.4255,
  //     longitude: -111.94,
  //   },
  //   {
  //     id: 403,
  //     name: "temple",
  //     state: "tx",
  //     population: 89000,
  //     latitude: 31.0963,
  //     longitude: -97.34,
  //   },
  //   {
  //     id: 404,
  //     name: "the woodlands",
  //     state: "tx",
  //     population: 120202,
  //     latitude: 30.1658,
  //     longitude: -95.4613,
  //   },
  //   {
  //     id: 405,
  //     name: "thousand oaks",
  //     state: "ca",
  //     population: 126966,
  //     latitude: 34.1704,
  //     longitude: -118.8376,
  //   },
  //   {
  //     id: 406,
  //     name: "toledo",
  //     state: "oh",
  //     population: 265304,
  //     latitude: 41.6639,
  //     longitude: -83.5552,
  //   },
  //   {
  //     id: 407,
  //     name: "toms river",
  //     state: "nj",
  //     population: 95232,
  //     latitude: 39.9571,
  //     longitude: -74.1979,
  //   },
  //   {
  //     id: 408,
  //     name: "topeka",
  //     state: "ks",
  //     population: 126587,
  //     latitude: 39.0473,
  //     longitude: -95.6756,
  //   },
  //   {
  //     id: 409,
  //     name: "torrance",
  //     state: "ca",
  //     population: 143587,
  //     latitude: 33.8358,
  //     longitude: -118.34,
  //   },
  //   {
  //     id: 410,
  //     name: "trenton",
  //     state: "nj",
  //     population: 84913,
  //     latitude: 40.2209,
  //     longitude: -74.7645,
  //   },
  //   {
  //     id: 411,
  //     name: "troy",
  //     state: "mi",
  //     population: 84134,
  //     latitude: 42.6075,
  //     longitude: -83.1499,
  //   },
  //   {
  //     id: 412,
  //     name: "tucson",
  //     state: "az",
  //     population: 554013,
  //     latitude: 32.2226,
  //     longitude: -110.9747,
  //   },
  //   {
  //     id: 413,
  //     name: "tulsa",
  //     state: "ok",
  //     population: 411894,
  //     latitude: 36.154,
  //     longitude: -95.9928,
  //   },
  //   {
  //     id: 414,
  //     name: "tyler",
  //     state: "tx",
  //     population: 109867,
  //     latitude: 32.3507,
  //     longitude: -95.3001,
  //   },
  //   {
  //     id: 415,
  //     name: "tysons",
  //     state: "va",
  //     population: 24075,
  //     latitude: 38.9167,
  //     longitude: -77.2289,
  //   },
  //   {
  //     id: 416,
  //     name: "union city",
  //     state: "nj",
  //     population: 66455,
  //     latitude: 40.7845,
  //     longitude: -74.0304,
  //   },
  //   {
  //     id: 417,
  //     name: "urban honolulu",
  //     state: "hi",
  //     population: 341778,
  //     latitude: 21.3069,
  //     longitude: -157.8583,
  //   },
  //   {
  //     id: 418,
  //     name: "upper east side",
  //     state: "ny",
  //     population: 215000,
  //     latitude: 40.7738,
  //     longitude: -73.9576,
  //   },
  //   {
  //     id: 419,
  //     name: "upper west side",
  //     state: "ny",
  //     population: 209000,
  //     latitude: 40.787,
  //     longitude: -73.9749,
  //   },
  //   {
  //     id: 420,
  //     name: "vacaville",
  //     state: "ca",
  //     population: 102379,
  //     latitude: 38.3568,
  //     longitude: -121.9864,
  //   },
  //   {
  //     id: 421,
  //     name: "vallejo",
  //     state: "ca",
  //     population: 126095,
  //     latitude: 38.1041,
  //     longitude: -122.2561,
  //   },
  //   {
  //     id: 422,
  //     name: "vancouver",
  //     state: "wa",
  //     population: 167405,
  //     latitude: 45.6387,
  //     longitude: -122.6615,
  //   },
  //   {
  //     id: 423,
  //     name: "ventura",
  //     state: "ca",
  //     population: 108390,
  //     latitude: 34.2796,
  //     longitude: -119.2968,
  //   },
  //   {
  //     id: 424,
  //     name: "victorville",
  //     state: "ca",
  //     population: 136932,
  //     latitude: 34.5361,
  //     longitude: -117.2917,
  //   },
  //   {
  //     id: 425,
  //     name: "vineland",
  //     state: "nj",
  //     population: 60780,
  //     latitude: 39.4893,
  //     longitude: -75.0343,
  //   },
  //   {
  //     id: 426,
  //     name: "virginia beach",
  //     state: "va",
  //     population: 453649,
  //     latitude: 36.8529,
  //     longitude: -75.978,
  //   },
  //   {
  //     id: 427,
  //     name: "visalia",
  //     state: "ca",
  //     population: 148700,
  //     latitude: 36.3308,
  //     longitude: -119.2926,
  //   },
  //   {
  //     id: 428,
  //     name: "waco",
  //     state: "tx",
  //     population: 141065,
  //     latitude: 31.5493,
  //     longitude: -97.1467,
  //   },
  //   {
  //     id: 429,
  //     name: "warren",
  //     state: "mi",
  //     population: 139366,
  //     latitude: 42.4925,
  //     longitude: -83.0238,
  //   },
  //   {
  //     id: 430,
  //     name: "washington",
  //     state: "dc",
  //     population: 702250,
  //     latitude: 38.9072,
  //     longitude: -77.0369,
  //   },
  //   {
  //     id: 431,
  //     name: "waterbury",
  //     state: "ct",
  //     population: 114407,
  //     latitude: 41.554,
  //     longitude: -73.0425,
  //   },
  //   {
  //     id: 432,
  //     name: "waukegan",
  //     state: "il",
  //     population: 89083,
  //     latitude: 42.3639,
  //     longitude: -87.8445,
  //   },
  //   {
  //     id: 433,
  //     name: "west covina",
  //     state: "ca",
  //     population: 109501,
  //     latitude: 34.0583,
  //     longitude: -117.9234,
  //   },
  //   {
  //     id: 434,
  //     name: "west palm beach",
  //     state: "fl",
  //     population: 120932,
  //     latitude: 26.7153,
  //     longitude: -80.0564,
  //   },
  //   {
  //     id: 435,
  //     name: "westminster",
  //     state: "ca",
  //     population: 90911,
  //     latitude: 33.7583,
  //     longitude: -118.0069,
  //   },
  //   {
  //     id: 436,
  //     name: "westminster",
  //     state: "co",
  //     population: 105084,
  //     latitude: 39.8369,
  //     longitude: -105.0789,
  //   },
  //   {
  //     id: 437,
  //     name: "westland",
  //     state: "mi",
  //     population: 85669,
  //     latitude: 42.3167,
  //     longitude: -83.3917,
  //   },
  //   {
  //     id: 438,
  //     name: "weymouth",
  //     state: "ma",
  //     population: 57488,
  //     latitude: 42.2032,
  //     longitude: -70.9328,
  //   },
  //   {
  //     id: 439,
  //     name: "wichita",
  //     state: "ks",
  //     population: 396119,
  //     latitude: 37.6872,
  //     longitude: -97.33,
  //   },
  //   {
  //     id: 440,
  //     name: "wichita falls",
  //     state: "tx",
  //     population: 102000,
  //     latitude: 33.9137,
  //     longitude: -98.4936,
  //   },
  //   {
  //     id: 441,
  //     name: "williamsburg",
  //     state: "ny",
  //     population: 204125,
  //     latitude: 40.71,
  //     longitude: -73.9642,
  //   },
  //   {
  //     id: 442,
  //     name: "wilmington",
  //     state: "de",
  //     population: 70635,
  //     latitude: 39.7459,
  //     longitude: -75.5466,
  //   },
  //   {
  //     id: 443,
  //     name: "wilmington",
  //     state: "nc",
  //     population: 106476,
  //     latitude: 34.2257,
  //     longitude: -77.9447,
  //   },
  //   {
  //     id: 444,
  //     name: "winston-salem",
  //     state: "nc",
  //     population: 252975,
  //     latitude: 36.1024,
  //     longitude: -80.252,
  //   },
  //   {
  //     id: 445,
  //     name: "woodbridge",
  //     state: "nj",
  //     population: 100985,
  //     latitude: 40.5621,
  //     longitude: -74.2921,
  //   },
  //   {
  //     id: 446,
  //     name: "woodbury",
  //     state: "mn",
  //     population: 77148,
  //     latitude: 44.9125,
  //     longitude: -92.9519,
  //   },
  //   {
  //     id: 447,
  //     name: "woodside",
  //     state: "ny",
  //     population: 80000,
  //     latitude: 40.7469,
  //     longitude: -73.9044,
  //   },
  //   {
  //     id: 448,
  //     name: "worcester",
  //     state: "ma",
  //     population: 206894,
  //     latitude: 42.2626,
  //     longitude: -71.8023,
  //   },
  //   {
  //     id: 449,
  //     name: "wyoming",
  //     state: "mi",
  //     population: 76547,
  //     latitude: 42.9239,
  //     longitude: -85.7003,
  //   },
  //   {
  //     id: 450,
  //     name: "yonkers",
  //     state: "ny",
  //     population: 211569,
  //     latitude: 40.9312,
  //     longitude: -73.8263,
  //   },
];
